import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Frap from 'shared/app/components/frap-with-messages';

import LegacyPaddedContentColumn from 'shared/app/components/legacy-padded-content-column';

import { sharedCallsToAction } from 'shared/app/messages/ctas';

import messages from './messages';

const ValidatePasswordReset = () => {
  return (
    <LegacyPaddedContentColumn className="text-sm" size="sm">
      <p className="pt5">
        <FormattedMessage {...messages.expiredPasswordResetMessage} />
      </p>
      <div className="flex justify-end mt6">
        <Frap tagName={Link} to="/account/forgot-password">
          <FormattedMessage {...sharedCallsToAction.tryAgain} />
        </Frap>
      </div>
    </LegacyPaddedContentColumn>
  );
};

export default ValidatePasswordReset;
